module.exports = __webpack_public_path__ + "media/scholarship_winners/emma-c-f95f15fe.png";